/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimVisualReferenceVisualReferenceRect } from './TimVisualReferenceVisualReferenceRect';
import {
    TimVisualReferenceVisualReferenceRectFromJSON,
    TimVisualReferenceVisualReferenceRectFromJSONTyped,
    TimVisualReferenceVisualReferenceRectToJSON,
    TimVisualReferenceVisualReferenceRectToJSONTyped,
} from './TimVisualReferenceVisualReferenceRect';

/**
 * 
 * @export
 * @interface TimVisualReferenceVisualReference
 */
export interface TimVisualReferenceVisualReference {
    /**
     * 
     */
    rect: TimVisualReferenceVisualReferenceRect;
    /**
     * 
     */
    text: string;
    /**
     * 
     */
    page_num: string;
    /**
     * 
     */
    document_id: string;
    /**
     * 
     */
    document_name: string;
}

/**
 * Check if a given object implements the TimVisualReferenceVisualReference interface.
 */
export function instanceOfTimVisualReferenceVisualReference(value: object): value is TimVisualReferenceVisualReference {
    if (!('rect' in value) || value['rect'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('page_num' in value) || value['page_num'] === undefined) return false;
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('document_name' in value) || value['document_name'] === undefined) return false;
    return true;
}

export function TimVisualReferenceVisualReferenceFromJSON(json: any): TimVisualReferenceVisualReference {
    return TimVisualReferenceVisualReferenceFromJSONTyped(json, false);
}

export function TimVisualReferenceVisualReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimVisualReferenceVisualReference {
    if (json == null) {
        return json;
    }
    return {
        
        'rect': TimVisualReferenceVisualReferenceRectFromJSON(json['rect']),
        'text': json['text'],
        'page_num': json['page_num'],
        'document_id': json['document_id'],
        'document_name': json['document_name'],
    };
}

export function TimVisualReferenceVisualReferenceToJSON(json: any): TimVisualReferenceVisualReference {
    return TimVisualReferenceVisualReferenceToJSONTyped(json, false);
}

export function TimVisualReferenceVisualReferenceToJSONTyped(value?: TimVisualReferenceVisualReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rect': TimVisualReferenceVisualReferenceRectToJSON(value['rect']),
        'text': value['text'],
        'page_num': value['page_num'],
        'document_id': value['document_id'],
        'document_name': value['document_name'],
    };
}

